module.exports = __webpack_public_path__ + "static/media/shoes.0ff8b504.jpg";